<template>
  <b-overlay
    :show="show"
    spinner-variant="primary"
    spinner-type="grow"
    spinner-small
    rounded="sm"
  >
    <b-card no-body>

      <b-row>
        <b-col sm="12">
          <b-card-body>
            <div class="text-center text-md-left">
              <h3 class="">
                {{ $t('crypto-deposit-title') }}
              </h3>
              <h5 class="my-2">
                {{ $t('crypto-deposit-description', { currency: coin }) }}
              </h5>
            </div>
            <dashboard-alert
              variant="danger"
              :description="$t('deposit-warning-dec', { currency: coin })"
            />
            <GetDescription name="crypto-deposit" />
            <b-form class="mt-2">
              <b-row>
                <b-col
                  cols="12"
                  lg="4"
                >
                  <b-form-group
                    label-for="coin"
                    :label="$t('coin')"
                  >
                    <b-form-input
                      id="coin"
                      v-model="coin"
                      readonly
                      name="coin"
                      :placeholder="$t('coin')"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                  cols="12"
                  lg="4"
                >
                  <b-form-group
                    label-for="network"
                    :label="$t('Network')"
                  >
                    <b-form-select
                      id="network"
                      v-model="network"
                      text-field="network.nick_name"
                      value-field="network.nick_name"
                      :options="coinInfo.currency_network"
                      :placeholder="$t('Network')"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                  v-if="walletAddress"
                  cols="12"
                  lg="4"
                >
                  <b-form-group
                    id="popover-manual-1"
                    label-for="walletAddress"
                    :label="$t('walletAddress')"
                  >
                    <copy-to-clipboard
                      :text="walletAddress"
                      @copy="copyAddress"
                    >
                      <b-input-group class="mb-2">
                        <b-form-input
                          id="walletAddress"
                          v-model="walletAddress"
                          readonly
                          name="walletAddress"
                          :placeholder="$t('walletAddress')"
                        />
                        <b-input-group-append>
                          <div class="d-flex align-items-center px-2 cursor-pointer bg-primary rounded-right">
                            <BIconClipboard
                              font-scale="1.5"
                              variant="white"
                            />
                          </div>
                        </b-input-group-append>
                      </b-input-group>
                    </copy-to-clipboard>
                    <b-popover
                      target="popover-manual-1"
                      :show.sync="pop1"
                      triggers="click"
                      placement="bottom"
                    >
                      {{ $t('copied') }}
                    </b-popover>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-form>
            <div
              class=" text-center mx-auto d-flex justify-content-end align-center"
            >
              <p>{{ $t('crypto-deposit-qr-code-guide') }}</p>
              <p
                class="text-decoration-underline text-primary cursor-pointer"
                @click="openQrModal"
              >
                {{ $t('crypto-deposit-qr-code-show') }}
              </p>
            </div>
          </b-card-body>
        </b-col>
      </b-row>
    </b-card>

    <b-card
      v-if="items.length > 0"
      :title="$t('lastDeposits')"
    >
      <b-row
        align-h="center"
      >
        <b-col cols="12">

          <HistoryCard
            :items="items"
            :fields="fields"
          >
            <template #item(created_at)="{ value}">
              <div dir="ltr">
                <h5>{{ getFormattedDate(value) }}</h5>
              </div>
            </template>
            <template #item(transaction_id)="{ value, item }">
              <span
                class="text-info"
                size="sm"
                style="display: block; cursor: pointer;"
                :disabled="!value"
                @click="() => triggerTransactionModal(item)"
              >
                {{ $t('transaction_id') }}
              </span>
            </template>
            <template #item(status)="{ value }">

              <span
                :class="value === 'pending' ? 'text-warning' :value === 'success' ? 'text-success' : 'text-danger'"
                size="sm"
                style="display: block;"
              >
                {{ $t(value) }}
              </span>

            </template>
          </HistoryCard>
          <!-- </div> -->
        </b-col>
      </b-row>
    </b-card>
    <b-col cols="auto">
      <b-pagination
        v-if="totalTransactions > perPageTransactions"
        v-model="currentpageTransactions"
        :total-rows="totalTransactions"
        :per-page="perPageTransactions"
        align="fill"
        size="sm"
        class="mb-1"
      />
    </b-col>
    <b-modal
      v-model="transactionIdModal"
      centered
      :title="$t('show_transaction_id')"
      ok-only
      :ok-title="$t('show_in_network')"
      :ok-disabled="!selectedTransactionNetwork"
      header-bg-variant="primary"
      @ok="openTransaction"
    >
      <b-form-group
        id="popover-manual-2"
        label-for="transaction_id"
        :label="$t('transaction_id')"
      >
        <copy-to-clipboard
          :text="selectedTransactionId"
          @copy="copyTransaction"
        >
          <b-input-group class="mb-2">
            <b-form-input
              id="transaction_id"
              v-model="selectedTransactionId"
              readonly
              name="transaction_id"
              :placeholder="$t('transaction_id')"
            />
            <b-input-group-append>
              <div class="d-flex align-items-center px-2 cursor-pointer bg-primary rounded-right">
                <BIconClipboard
                  font-scale="1.5"
                  variant="white"
                />
              </div>
            </b-input-group-append>
          </b-input-group>
        </copy-to-clipboard>
        <b-popover
          target="popover-manual-2"
          :show.sync="pop2"
          triggers="click"
          placement="bottom"
        >
          {{ $t('copied') }}
        </b-popover>
      </b-form-group>
    </b-modal>
    <b-modal
      v-model="qrModal"
      centered
      size="sm"
      hide-footer
      no-close-on-backdrop
      header-bg-variant="primary"
    >
      <div class="text-center d-flex justify-content-center p-5">
        <qrcode-vue
          v-if="walletAddress"
          :value="walletAddress"
          :background="isDarkTheme ? '#283046' : '#fff'"
          :foreground="isDarkTheme ? '#fff' : '#283046'"
          :size="size"
          class="qrcode"
        />
      </div>
    </b-modal>
  </b-overlay>
</template>
<script>
import cryptoDeposit from '@/modules/crypto/views/logic/customer-wallets/cryptoDeposit'
import DashboardAlert from '@/views/theme2/dashboard/dashboardAlert.vue'
import { BIconClipboard } from 'bootstrap-vue'
import HistoryCard from '../components/historyCard.vue'

export default {
  components: {
    DashboardAlert,
    BIconClipboard,
    HistoryCard,
  },
  mixins: [cryptoDeposit],
}
</script>
<style lang="scss">
.card-border {
  border-right: 1px solid #e3e1e9;
}

.transaction-card {
  background-color: #efefef;
  padding: 15px;
  border-radius: 5px;
}

.card-bg {
  background-color: #172238;
  padding: 15px;
  border-radius: 5px;
}

.nameOfTheClass {
  padding: 20px !important;
}
</style>
<style scoped>
::v-deep .qrcode{
  width: 150px;
  height: 150px;
}
::v-deep .qrcode canvas{
  width: 100% !important;
}
</style>
